import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
	Button,
	Drawer,
	Form,
	Input,
	Select,
	TimePicker,
	TreeSelect,
} from "antd";
import PropTypes from "prop-types";
import moment from "moment-jalaali";
import { DatePicker, useJalaliLocaleListener } from "antd-jalali";
// import dayjs from "dayjs";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import InputCurrency from "components/InputCurrency";
import UploadImage from "components/UploadImage";
import TextEditor from "components/TextEditor";

const Component = ({
	data = {},
	onUpdate,
	options: { categories = [], images = [], files = [] },
}) => {
	const initialState = { editTime: false, chosenImage: "" };
	const [state, setState] = useState(initialState);
	const { editTime, submitting, visible, chosenImage } = state;
	const { code, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				if (!values.discountedPrice) {
					values.discountExpiresAt = null;
				}

				if (values.discountedPrice && values.discountExpiresAt)
					values.discountExpiresAt = moment(values.discountExpiresAt.$d).format(
						process.env.REACT_APP_DATE_TIME_FORMAT
					);

				if (values.description) {
					values.description = values.description.replaceAll(
						/<\/p><p>/g,
						"<br />"
					);
					values.description = values.description.replaceAll("<br>", "");
					values.description = values.description.replaceAll(
						/<\/p><p\s+class="[^"]*">/g,
						"<br />"
					);
				}

				const action =
					hash === `#${Modals.CREATE}`
						? API.course.create(values)
						: API.course.update(code, values);

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.finally(() => {
						setState((prevState) => ({ ...prevState, submitting: false }));
					});
			});
		}
	};

	useJalaliLocaleListener();
	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (code) {
					setState((prevState) => ({
						...prevState,
						visible: true,
						chosenImage: data?.cover?.url,
					}));

					form.setFieldsValue({
						...data,
						// files: data?.files?.map(({ title, id }) => ({
						// 	label: title,
						// 	value: id,
						// })),
						discountExpiresAt:
							data.discountExpiresAt &&
							moment(data.discountExpiresAt).format(
								process.env.REACT_APP_DATE_TIME_FORMAT_JALALI
							),
						coverId: data.cover?.id,
						categoryId: data.category?.id,
					});
				} else {
					navigate({ pathname, search }, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						disabled={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={
				hash === `#${Modals.CREATE}`
					? `${Resources.add} ${Resources.course}`
					: `${Resources.edit} ${Resources.course} "${title}"`
			}
			maskClosable={false}
			open={visible}
			width={768}
		>
			<Form
				layout="vertical"
				form={form}
			>
				<>
					<Form.Item
						name="title"
						label={Resources.title}
						rules={Rules.required}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="categoryId"
						label={Resources.category}
						rules={Rules.required}
					>
						<TreeSelect
							treeData={categories}
							allowClear
						/>
					</Form.Item>
					<Form.Item
						name="price"
						label={Resources.price}
						rules={Rules.required}
					>
						<InputCurrency />
					</Form.Item>
					<Form.Item
						name="discountedPrice"
						label={`${Resources.price} ${Resources.with} ${Resources.discount}`}
					>
						<InputCurrency />
					</Form.Item>
					<Form.Item
						name="discountExpiresAt"
						label={`${Resources.date} ${Resources.expire} ${Resources.discount}`}
					>
						{editTime ? (
							<DatePicker showTime />
						) : (
							<Input
								onClick={() => {
									setState((prevState) => ({ ...prevState, editTime: true }));
									form.setFieldValue("discountExpiresAt", "");
								}}
							/>
						)}
					</Form.Item>
					<Form.Item
						name="published"
						label={`${Resources.status} ${Resources.publish}`}
						rules={Rules.required}
					>
						<Select
							options={[
								{ label: `${Resources.published}`, value: true },
								{ label: `${Resources.unpublished}`, value: false },
							]}
						/>
					</Form.Item>
					<Form.Item
						name="summary"
						label={Resources.summary}
						rules={Rules.required}
					>
						<Input.TextArea rows={2} />
					</Form.Item>
					<Form.Item
						name="description"
						label={Resources.description}
						rules={Rules.required}
					>
						<TextEditor />
					</Form.Item>

					{/* <Form.Item
						name="files"
						label={`${Resources.file}${Resources.ha}`}
					>
						<Select
							options={files}
							mode="multiple"
						/>
					</Form.Item> */}

					<Form.Item
						name="coverId"
						label={Resources.image}
						rules={Rules.required}
					>
						<Select
							options={images}
							optionFilterProp="label"
							onChange={(e, element) => {
								setState((prev) => ({ ...prev, chosenImage: element.file }));
							}}
							showSearch
						/>
					</Form.Item>
					{chosenImage ? (
						<img
							src={chosenImage}
							className="image"
							style={{
								width: "50%",
								objectFit: "cover",
								margin: "0 auto",
								display: "block",
							}}
						/>
					) : (
						""
					)}
				</>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
